
































































import { Component, Vue, Prop } from "vue-property-decorator";
import { AppConstants, apiService } from "@/core/Export";

import store from "@/store";

@Component({ components: {} })
export default class ApprovalToEmail extends Vue {
  @Prop() email: string;
  @Prop() displaySendByMailDialog: boolean;
  displayErrors: boolean;
  emailLocal = "";

  constructor() {
    super();
  }

  created() {
    this.displayErrors = false;
    this.emailLocal = this.email;
  }

  onSendByMail() {
    this.displayErrors = true;
    let verfiyResidentForm = this.$refs.form as any;
    var vv = verfiyResidentForm.validate();
    verfiyResidentForm.validate().then((success) => {
      if (success) {
        this.appEnv.isBusy = true;
        var emails = new Array<any>();
        emails.push(this.emailLocal);
        apiService
          .post("Approvment/SendIshurToshavByEmail", {
            emailAddresses: emails,
            requestId: this.appEnv.requestParams.requestId,
          })
          .then((result) => {
            if (result && result.isSuccess) {
              if (result.msgs.msgs && result.msgs.msgs.length > 0) {
                this.appEnv.showErrorDialog(result.msgs.msgs, true);
              } else {
                this.displaySendByMailDialogLocal = false;
                this.$q.notify({
                  color: "positive",
                  message: 'הדוא"ל נשלח בהצלחה',
                });
              }
            } else {
              this.appEnv.showErrorDialog(result.msgs.msgs, true);
            }
          })
          .finally(() => {
            this.appEnv.isBusy = false;
          });
      }
    });
  }

  onValidateEmail() {
    let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRegex.test(this.emailLocal);
  }
  set displaySendByMailDialogLocal(value) {
    this.$emit("update:displaySendByMailDialog", value);
  }

  get displaySendByMailDialogLocal() {
    return this.displaySendByMailDialog;
  }

  get appEnv() {
    return store.getters.appEnv;
  }
}
